export interface Selectable<T = unknown> {
  label: string;
  value: T;
}

export function isSelectable<T>(value: unknown): value is Selectable<T> {
  return typeof value === 'object' && value !== null && 'label' in value && 'value' in value;
}
